<template>
  <div>
    <div class="container" v-loading="indexLoading" :element-loading-text="loadingText" @click="cancel">
      <!-- 第一部分内容 -->
      <payment-first :flag="flag" @openFirst="openFirst" @newApplyPC="newApplyPC" ></payment-first>
      <!-- 第二部分和第一部分之间的卡片图片 -->
      <div class="payment-card">
        <div class="payment-card-user" v-if="realname === ''">HI:*****</div>
        <div class="payment-card-user" v-if="realname !== ''">
          HI, {{ realname }}
        </div>
        <div class="creditMoney" v-if="creditDetails && creditDetails.creditLimit">
          $ {{paddingNum(creditDetails.creditLimit)}}
        </div>
        <div class="creditMoney" v-else>
          $ ******
        </div>
        <img class="img-con" src="../../assets/pay-card-1x.png" />
      </div>
      <!-- 第二部分 -->
      <payment-second></payment-second>
      <!-- 第三部分 -->
      <payment-third></payment-third>
      <!-- 第四部分 -->
      <payment-fourth></payment-fourth>
      <!-- 第五部分 -->
      <payment-fifth></payment-fifth>
      <!-- 第六部分 -->
      <payment-six></payment-six>
      <!-- 底部 -->
      <footer-com></footer-com>
    </div>

    <!-- 人工验证好的三种状态 -->
    <template v-if="step == 'first' && renderLoading">
      <Verify
        :renderLoading='renderLoading'
        :flag="flag"
        :step="step"
        :bankFlag="bankFlag"
        :business="business"
        :checkoutPath="checkoutPath"
        @openSecond="openSecond"
        @closeFirst="closeFirst"
      ></Verify>
    </template>
    <!-- 第二步 -->
    <!-- 更改方式(后面代码暂时注释) v-loading="indexLoading" :element-loading-text="loadingText" -->
    <template v-if="step == 'second'" >
      <CreditDialog
        @closeSecond="closeSecond"
        @openThird="openThird"
        :onInterval="onInterval"
        @handleBank="handleBank"
      ></CreditDialog>
    </template>

    <!-- <CreditAuditDialog></CreditAuditDialog> -->
    <template v-if="step == 'third'">
      <el-dialog :visible.sync="thirdVisible" :show-close="false">
        <AuditDialog :step="step" @closeThird="closeThird" @backFirst="backFirst"></AuditDialog>
      </el-dialog>
    </template>
    <!-- completed application 按钮弹框 -->
    <template v-if="step == 'completedApplication'">
      <completed-application @queryStatus="queryStatus" @closeCompletedApplication="closeCompletedApplication" ref="completedApplication"/>
    </template>
  </div>
</template>

<script>
import PaymentFifth from './payment-fifth.vue'
import paymentFirst from './payment-first.vue'
import PaymentFourth from './payment-fourth.vue'
import PaymentSecond from './payment-second.vue'
import PaymentThird from './payment-third.vue'
import FooterCom from '../components/footer.vue'
import PaymentSix from './payment-six.vue'
import CreditDialog from './creditDialog.vue'
import Verify from './verifyDialog.vue'
import ApplyDialog from './applyDialog.vue'
import CreditAuditDialog from './creditAuditDailog.vue'
import AuditDialog from './auditDialog.vue'
import { getAction } from '@/api/manage.js'
import CompletedApplication from './completedApplication.vue'
export default {
  components: {
    paymentFirst,
    PaymentSecond,
    PaymentThird,
    PaymentFourth,
    PaymentFifth,
    FooterCom,
    PaymentSix,
    CreditDialog,
    Verify,
    ApplyDialog,
    CreditAuditDialog,
    AuditDialog,
    CompletedApplication
  },
  data() {
    return {
      completedApplicationVisible: true, // 因为外侧有v-if控制显隐 这里直接赋值true
      business: '',
      thirdVisible: false,
      indexLoading: false,
      loadingText: '',
      flag: '',
      step: 'first',
      realname: '',
      creditDetails: {},
      interval: null,
      renderLoading: false,
      bankFlag: 'false',
      checkoutPath: '', // 从checkout过来的话要给其赋值，方便回跳
      timeOut: 0 // 控制不第一时间关掉loading
    }
  },
  watch: {
    step(newValue, oldValue) {
      this.step = newValue
    }
  },
  created() {
    mixpanel.track('v_nt_introduce')
    if (this.login) {
      const realname = this.$ls.get('realname')
      if (realname !== undefined && realname !== null && realname !== '') {
        this.realname = realname
      }
      // TODO haoyuanw add 预申请页面
      // eslint-disable-next-line no-undef
      mixpanel.track('pv_net_term_view')
      // TODO haoyuan add  2021-11-05将原有逻辑去掉
      // // 判断是否是checkout过来的,只需要判断是否有参数传过来
      // if (window.location.href.includes('?')) {
      //   this.checkoutPath = window.location.href.substring(window.location.href.indexOf('?') + 1, window.location.href.length)
      // } else {
      //   // 如果没有带参数，说明不是点击net term 的连接过来的。此时判断localStorage中是否存在checkoutPath ，如果存在则赋值
      //   if (localStorage.getItem('checkoutPath') !== '' && localStorage.getItem('checkoutPath') !== undefined && localStorage.getItem('checkoutPath') !== null) {
      //     // this.checkoutPath = JSON.parse(localStorage.getItem('checkoutPath')).value
      //     this.checkoutPath = localStorage.getItem('checkoutPath')
      //     console.log(this.checkoutPath)
      //   }
      // }
      // this.getCreditLimit()
      // TODO 判断是不是刚申请的，如果是则跳转过来需要显示审核中

      if (localStorage.getItem('apply_status') !== null) {
        this.step = 'first'
        this.flag = 'completed'
        this.getShopInfo()
        this.renderLoading = true
      } else {
        this.loadPCStatus()
      }
      if (localStorage.getItem('checkout') !== null) {
        this.checkoutPath = localStorage.getItem('checkout')
      }
    }
  },
  methods: {
    /**
     * 查询PC状态
     */
    loadPCStatus() {
      getAction('/slope/prod/pc-net').then(response => {
        if (response.success) {
          if (response.result !== null) {
            if (response.result.pcNetQualificationStatus !== null) {
              this.flag = response.result.pcNetQualificationStatus
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    getShopInfo() {
      getAction('/shop-user/info').then(response => {
        if (response.success) {
          if (response.result !== null) {
            this.business = response.result.email
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    cancel() {
      if (this.indexLoading && this.timeOut > 1) {
        this.indexLoading = false
        this.loadingText = ''
        this.timeOut = 0
      }
    },
    /**
     * haoyuanw add 2021-11-05 添加点击apply 显示遮罩层
     */
    newApplyPC() {
      // TODO 2022-01-06 haoyuanw 更新预授信逻辑，需要跳转到新的路由 进行预授信
      this.$router.push({path: '/apply'})
      // this.indexLoading = true
      // this.loadingText = 'Activate Net 60 Term when you place an order'
      // this.interval = setInterval(() => {
      //   this.timeOut += 1
      //   if (this.timeOut > 1) {
      //     clearInterval(this.interval)
      //   }
      // }, 1000)
    },
    backFirst(status, business) {
      // 将third dialog 隐藏
      this.thirdVisible = false
      // 将 第一步申请状态的弹框显示出来
      this.flag = status
      this.step = 'first'
      this.business = business
      this.renderLoading = true
    },
    /**
     * 当点击 银行卡授信的时候 需要 加一个条件来判断
     * 更新后逻辑：
     * 1、将当前的预申请弹框关闭
     * 2、将completed application 弹框弹出
     */
    handleBank(bankFlag) {
      // 弹出completed application 弹框，并且银行预申请方式选择的弹框隐藏
      this.step = 'completedApplication'
      // this.bankFlag = bankFlag 该行代码暂时不能在这里赋值
      // 暂时隐藏，更改逻辑
      // this.indexLoading = true
      // this.loadingText = 'Connecting to your bank'
    },
    /**
     * 将该弹框关闭，并且显示选择申请方式的弹框
     */
    closeCompletedApplication() {
      this.step = 'second'
    },
    /**
     * 查询
     */
    queryStatus() {
      this.queryStatusInterval()
      // 这里判断一下是否将step 更改为first了，如果更改了first了 说明状态变化了
    },
    /**
     * haoyuanw add 2021-10-18 增加方法，如果10秒钟之内查询不出来状态的改变则给出提示信息
     */
    queryStatusInterval() {
      let times = 0
      this.interval = setInterval(() => {
        getAction('/balance/creditLimit').then((res) => {
          if (res.code === 200) {
            if (res.success) {
              if ((res.result.qualificationStatus !== '' && res.result.qualificationStatus !== 'pending') || times === 3) {
                clearInterval(this.interval)
              } else {
                times++
                return
              }
            }
            // 点击申请后，就会间隔调用该方法 因为默认的状态要么是pending 要么是'' 所以只要返回的状态不是这2个，说明提交了就取消加载、清空调用并且显示状态的信息
            // if (this.flag !== res.result.qualificationStatus) {
            if (res.result.qualificationStatus !== '' && res.result.qualificationStatus !== 'pending') {
              // 修改状态
              this.flag = res.result.qualificationStatus
              // 显示first 组件
              this.step = 'first'
              this.renderLoading = true
              // 取消加载
              this.indexLoading = false
              this.loadingText = ''
              this.bankFlag = true
            } else {
              // 状态如果没有更改，还是未申请的状态，说明没有提交银行信息，或者银行信息输入不正确导致该流程没有完成
              this.$message.warning('Not applied net terms')
              // 将当前的弹框关闭，并且取消加载状态
              this.$refs.completedApplication.closeCurrentDialog()
              this.step = ''
            }
          }
        })
      }, 2000)
    },
    onInterval() {
      this.interval = setInterval(() => {
        getAction('/balance/creditLimit').then((res) => {
          console.log(res, '余额信息')
          if (res.code === 200) {
            // 点击申请后，就会间隔调用该方法 因为默认的状态要么是pending 要么是'' 所以只要返回的状态不是这2个，说明提交了就取消加载、清空调用并且显示状态的信息
            // if (this.flag !== res.result.qualificationStatus) {
            if (res.result.qualificationStatus !== '' && res.result.qualificationStatus !== 'pending') {
              // 修改状态
              this.flag = res.result.qualificationStatus
              // 显示first 组件
              this.step = 'first'
              this.renderLoading = true
              // 取消加载
              this.indexLoading = false
              this.loadingText = ''
              clearInterval(this.interval)
            };
          }
        })
      }, 5000)
    },
    // 打开人工审核弹框
    // openMenual(v){
    //   this.flag = v
    // },
    openFirst(v) {
      this.step = v
    },
    closeFirst(v) {
      this.step = v
    },
    // 关闭人工审核
    closeSecond(v) {
      console.log(this.step, '关闭第二部之前')
      this.step = v
      console.log(this.step, '关闭第二部')
    },
    // 打开人工审核
    openSecond(v) {
      this.step = v
    },

    // 第三步
    openThird(v) {
      this.step = v
      this.thirdVisible = true
    },

    closeThird(v) {
      // console.log(v, '第三步')
      this.step = v
    },
    getCreditLimit() {
      this.renderLoading = false
      getAction('/balance/creditLimit').then((res) => {
        if (res.code == 200) {
          this.creditDetails = res.result
          this.flag = this.creditDetails.qualificationStatus
          if (this.flag === 'pending' || this.flag === '') {
            this.step = 'second'
            return
          }
          this.business = this.creditDetails.businessNameVidi
          this.renderLoading = true
        }
      })
    },
    paddingNum (num) {
      var str = num.toString()
      if (str.length <= 3) {
        return str
      }
      var integer = []
      var floater = []
      if (!str.includes('.')) {
        integer = str.split('')
        floater = '00'
      } else {
        // 传入的有小数
        var ary = str.split('.')
        integer = ary[0].split('')
        floater = ary[1]
      }
      let count = 0
      integer.length % 3 === 0 ? count = integer.length / 3 - 1 : count = Math.floor(integer.length / 3)
      // 开始循环
      for (var i = 0; i < count; i++) {
        integer.splice(integer.length - (i + 1) * 3 - i, 0, ',')
      }
      var finalStr = ''
      // 判断小数数组中是否存在数据，如果有数据则拼接小数，如果没有就返回整数数组
      floater.length === 0 ? finalStr = integer.join('') : finalStr = integer.join('') + '.' + floater

      return finalStr
    }
  }
}
</script>

<style lang="less" scoped>
.payment-card {
  width: auto;
  max-width: 1400px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  top: -220px;
}
.img-con{
  width: 529px;
}
.payment-card-user {
  text-align: left;
  position: absolute;
  top: 20px;
  color: white;
  font-size: 26px;
  width: 300px;
  left: 450px;
  overflow: hidden; white-space: nowrap; text-overflow: ellipsis
}
.creditMoney{
  text-align: left;
  position: absolute;
  top: 120px;
  color: white;
  font-size: 26px;
  width: 15%;
  left: 450px;
}
/deep/ .el-loading-mask{background-color:#262B2F !important; opacity: 0.8 !important;}
/deep/ .el-loading-spinner{color: #2b2b2b !important;top:8% !important;}
/deep/ .el-loading-text{color: #FFFFFF !important;
    top: 10px;
    width: 30%;
    margin: 0;
    margin: 0 auto !important;
    background: #000000;
    line-height: 51px;
    opacity: 0.8 !important}
/deep/ .el-loading-spinner .circular{color: #FFFFFF !important;display: none !important;}
@media screen and (max-width: 600px) {
  /deep/ .el-loading-text{
    width: 80%;
  }
  .payment-card {
    top: -150px;
    width: 80%;
  }
  .payment-card-user {
    left: 10px;
    top: 20px;
    font-size: 18px;
    width: 45%;
  }
  .creditMoney{
    font-size: 18px !important;
    top: 80px;
    color: white;
    font-size: 26px;
    width: 50%;
    left: 10px;
  }
}
@media screen and (max-width: 380px) {
  .payment-card-user{width: 30%;}
}
@media screen and (max-width: 320px) {
  .payment-card {
    top: -100px;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/index.vue